import { sqliteTable, text, real } from "drizzle-orm/sqlite-core";
import { fleetVehicles } from "./vehicles";

// ============================================================================
// insurance_records — ประวัติประกันภัย
// ============================================================================
export const insuranceRecords = sqliteTable("fleet_insurance_records", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  vehicleId: text("vehicle_id").notNull().references(() => fleetVehicles.id),
  insuranceType: text("insurance_type", {
    enum: ["class_1", "class_2", "class_3", "class_2_plus", "class_3_plus", "act"],
  }).notNull(),
  providerName: text("provider_name"),
  // #401 — Optional soft FK to accounting_partners.id; see garage_partner_id
  // comment on maintenance-records for rationale.
  providerPartnerId: text("provider_partner_id"),
  policyNumber: text("policy_number"),
  coverageAmount: real("coverage_amount"),
  premium: real("premium").default(0),
  startDate: text("start_date").notNull(),
  expiryDate: text("expiry_date").notNull(),
  paymentMethod: text("payment_method"),
  paymentId: text("payment_id"),
  documentUrl: text("document_url"),
  notes: text("notes"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type InsuranceRecord = typeof insuranceRecords.$inferSelect;
export type NewInsuranceRecord = typeof insuranceRecords.$inferInsert;
